<template>
    <a-modal :wrapClassName='$store.state.bgLight ? "lightColor" : ""' :title="title" :width="1200" :visible="visible" @ok="handleOk" @cancel="handleCancel" cancelText="关闭">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item label="编号">
              <a-input placeholder="请输入编号查询" v-model="queryParam.assetCode"></a-input>
            </a-form-item>
          </a-col>

          <a-col :span="6">
            <a-form-item label="名称">
              <a-input placeholder="请输入名称查询" v-model="queryParam.productName"></a-input>
            </a-form-item>
          </a-col>

          <a-col :span="6">
            <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchByquery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <a-table
      ref="table"
      bordered
      rowKey="id"
      :columns="columns"
      :dataSource="dataSource"
      :pagination="ipagination"
      :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange, type: 'radio' }"
      @change="handleTableChange"
    >
    </a-table>
  </a-modal>
</template>

<script>
import { filterObj } from '@/utils/util'
import { getAction } from '@/api/manage'

export default {
  name: 'SelectProductListModal',
  data() {
    return {
      title: '选择设备',
      queryParam: {},
      columns: [
        {
          title: '设备编号',
          align: 'center',
          dataIndex: 'assetCode',
          fixed: 'left',
          width: 200,
        },
        {
          title: '产品编号',
          align: 'center',
          dataIndex: 'productCode',
        },
        {
          title: '产品名称',
          align: 'center',
          dataIndex: 'productName',
        },
        {
          title: '规格型号',
          align: 'center',
          dataIndex: 'model',
        },
       {
          title: '安装位置',
          align: 'center',
          dataIndex: 'location',
        },
      ],
      dataSource: [],
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['5', '10', '20'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条'
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0,
      },
      selectedRowKeys: [],
      selectionRows: [],
      visible: false,
      toggleSearchStatus: false,
      siteId: '',
    }
  },
  created() {},
  methods: {
    add(selectUser, userIds) {
      this.visible = true
      this.edit(selectUser, userIds)
    },
    edit(selectUser, userIds) {
      this.loadData()
      if (!userIds) {
        this.selectedRowKeys = []
      } else {
        this.selectedRowKeys[0] = userIds
      }
      if (!selectUser) {
        this.selectionRows = []
      } else {
        this.selectionRows = selectUser
      }
    },
    loadData(arg) {
      if (arg === 1) {
        this.ipagination.current = 1
      }
      let params = this.getQueryParams() //查询条件
      getAction('/ea/asset/equipment?siteId=' + this.siteId, params).then((res) => {
        if (res.success) {
          this.dataSource = res.result.records
          this.ipagination.total = res.result.total
        }
      })
    },
    getQueryParams() {
      let param = Object.assign({}, this.queryParam, this.isorter)
      param.field = this.getQueryField()
      param.pageNo = this.ipagination.current
      param.pageSize = this.ipagination.pageSize
      param.status = 1
      return filterObj(param)
    },
    getQueryField() {
      let str = 'id,'
      for (let a = 0; a < this.columns.length; a++) {
        str += ',' + this.columns[a].dataIndex
      }
      return str
    },
    onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectionRows = selectionRows
    },
    searchReset() {
      let that = this
      Object.keys(that.queryParam).forEach(function (key) {
        that.queryParam[key] = ''
      })
      that.loadData(1)
    },
    handleTableChange(pagination, filters, sorter) {
      //TODO 筛选
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field
        this.isorter.order = 'ascend' == sorter.order ? 'asc' : 'desc'
      }
      this.ipagination = pagination
      this.loadData()
    },
    handleCancel() {
      this.selectionRows = []
      this.selectedRowKeys = []
      this.visible = false
    },
    handleOk() {
      if (this.selectionRows.length <= 0) {
        this.$message.warning('请选择一条记录！')
        return
      }
      this.$emit('selectProduct', this.selectionRows)
      this.handleCancel()
    },
    close() {
      this.selectionRows = []
      this.selectedRowKeys = []
      this.visible = false
    },
    searchByquery() {
      this.loadData(1)
    },
    handleToggleSearch() {
      this.toggleSearchStatus = !this.toggleSearchStatus
    },
  },
}
</script>
<style scoped>
.ant-card-body .table-operator {
  margin-bottom: 18px;
}

.ant-table-tbody .ant-table-row td {
  padding-top: 15px;
  padding-bottom: 15px;
}

.anty-row-operator button {
  margin: 0 5px;
}

.ant-btn-danger {
  background-color: #ffffff;
}

.ant-modal-cust-warp {
  height: 100%;
}

.ant-modal-cust-warp .ant-modal-body {
  height: calc(100% - 110px) !important;
  overflow-y: auto;
}

.ant-modal-cust-warp .ant-modal-content {
  height: 90% !important;
  overflow-y: hidden;
}

.anty-img-wrap {
  height: 25px;
  position: relative;
}

.anty-img-wrap > img {
  max-height: 100%;
}
</style>